import { render, staticRenderFns } from "./InstantUpdateTextField.vue?vue&type=template&id=57615173"
import script from "./InstantUpdateTextField.vue?vue&type=script&lang=ts"
export * from "./InstantUpdateTextField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports